import { AttributeInputCallback } from '@forgerock/javascript-sdk';

export type Policy = 'MATCH_REGEXP' | 'MIN_LENGTH' | 'MAX_LENGTH';

const getRegexpPolicy = (fieldName: string, forgeRockPolicy?: ForgeRockPolicy, isProfessional = false) =>
  getCustomRegexpPolicy(fieldName, isProfessional) ?? forgeRockPolicy?.params?.['regexp'];

export const getCustomRegexpPolicy = (fieldName: string, isProfessional = false) => {
  switch (fieldName) {
    case 'sn':
      if (isProfessional) {
        return "^[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'´\\-]{1,25}$";
      } else {
        return "^[a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'´\\-]{1,25}$";
      }
    case 'givenName':
      if (isProfessional) {
        return "^[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'´\\-]{1,25}$";
      } else {
        return "^[a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'´\\-]{1,15}$";
      }
    case 'postalAddress':
      return "^[0-9a-zA-Z\\sáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ'´’\\-]{1,30}$";
    case 'telephoneNumber':
      return '^0[1-79](?:\\s?\\d{2}){4}$';
    default:
      return undefined;
  }
};

export const extractPolicy = (
  callback: AttributeInputCallback<string | number | boolean>,
  wantedPolicy: Policy,
): string | number | undefined => {
  const forgeRockPolicies: ForgeRockPolicy[] = (callback.getPolicies() as ForgeRockPolicies)?.policies;
  const forgeRockPolicy = forgeRockPolicies?.filter((policy) => policy.policyRequirements.includes(wantedPolicy))?.pop();

  switch (wantedPolicy) {
    case 'MATCH_REGEXP':
      return getRegexpPolicy(callback.getName(), forgeRockPolicy);
    case 'MIN_LENGTH':
      return forgeRockPolicy?.params?.['minLength'];
    case 'MAX_LENGTH':
      return forgeRockPolicy?.params?.['maxLength'];
  }
};

interface ForgeRockPolicies {
  policies: ForgeRockPolicy[];
}

interface ForgeRockPolicy {
  policyRequirements: string[];
  params: never;
}
